import { ColorPicker, Form } from 'antd'
import { colorFieldValueToHex, DEFAULT_CLIENT_TEXT_COLOR } from '../clientFormShared'

export function ClientThemeColorFields() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
      <Form.Item name="primaryColor" label="Primary color" normalize={(v) => colorFieldValueToHex(v)}>
        <ColorPicker format="hex" showText allowClear className="w-full" />
      </Form.Item>
      <Form.Item name="secondaryColor" label="Secondary color" normalize={(v) => colorFieldValueToHex(v)}>
        <ColorPicker format="hex" showText allowClear className="w-full" />
      </Form.Item>
      <Form.Item
        name="textColor"
        label="Text color"
        normalize={(v) => colorFieldValueToHex(v) || DEFAULT_CLIENT_TEXT_COLOR}
      >
        <ColorPicker format="hex" showText className="w-full" />
      </Form.Item>
    </div>
  )
}
